// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.prompt-content[data-v-3485dcbd] {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px 8px;
  text-align: center;
}
.prompt-icon[data-v-3485dcbd] {
  margin-bottom: 16px;
}
.prompt-title[data-v-3485dcbd] {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
}
.prompt-message[data-v-3485dcbd] {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 28px;
}
.prompt-buttons[data-v-3485dcbd] {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.prompt-buttons[data-v-3485dcbd] .ant-btn-primary {
  border-radius: 8px;
  font-weight: 600;
  height: 44px;
}
.prompt-buttons[data-v-3485dcbd] .ant-btn-default {
  border-radius: 8px;
  height: 44px;
}
.dismiss-sub[data-v-3485dcbd] {
  font-size: 12px;
  color: #999;
  margin-left: 4px;
  font-weight: 400;
}
.prompt-buttons[data-v-3485dcbd] .ant-btn-link {
  color: #999;
  font-size: 13px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
